import React, { useRef, useState } from "react";
import Icon from "components/Elements/Icon/Icon";
import Image from "components/Elements/Image/Image";
import useMediaQueries from "hooks/useMediaQueries";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./styles.module.scss";

const REVIEWERS_NAMES = ["Nick Jackson", "Emily Clarkson", "Axel-Production"];
const STYLE_TRANSFORM_TRANSLATE = [
  "translateX(-100vw)",
  "translateX(0)",
  "translateX(100vw)",
];

const ReviewComponent = () => {
  const { getTextByKey } = useContent();
  const { mobileCondition } = useMediaQueries();
  const [currentReview, setCurrentReview] = useState(1);

  const handleClickForward = () => {
    if (currentReview === 0) {
      setCurrentReview(REVIEWERS_NAMES.length - 1);
    } else {
      setCurrentReview(currentReview - 1);
    }
  };

  const handleClickBackward = () => {
    if (currentReview === REVIEWERS_NAMES.length - 1) {
      setCurrentReview(0);
    } else {
      setCurrentReview(currentReview + 1);
    }
  };

  return (
    <>
      {mobileCondition && (
        <Icon
          name="arrow-down"
          iconClass={styles.arrowForward}
          onClick={handleClickForward}
        />
      )}
      <div
        className={styles.reviews}
        style={{
          transform: STYLE_TRANSFORM_TRANSLATE[currentReview],
        }}
      >
        {REVIEWERS_NAMES.map((name, index) => (
          <div className={styles.clientReview}>
            <div className={styles.reviewImage}>
              <Image name={"picker/review-company-" + (index + 1)} ext="png" />
            </div>
            <div className={styles.reviewTitle}>
              {" "}
              {getTextByKey("reviewer-name-" + (index + 1))}
            </div>
            <div className={styles.reviewSubtitle}>
              {getTextByKey("reviewer-subtitle-" + (index + 1))}
            </div>
            <p className={styles.reviewText}>
              {getTextByKey("reviewer-text-" + (index + 1))}
            </p>
          </div>
        ))}
      </div>
      {mobileCondition && (
        <Icon
          name="arrow-down"
          iconClass={styles.arrowBackward}
          onClick={handleClickBackward}
        />
      )}
    </>
  );
};

export default ReviewComponent;
